<button mat-flat-button
        type="button"
        color="primary"
        title="{{ 'directory.requests.addNewElement' | translate }}"
        (click)="openAdbSubrequest()">
    <em class="material-icons">add</em>
</button>